
<script>
import axios from "axios";
export default {
  get(key) {
    key = key == "" ? "adobe" : key;
    return axios
      .get("https://aravindtwitter.herokuapp.com/twittersearch?key=" + key) // <--- Need this to return the promise
      .then(response => {
        return response.data.statuses;
      })
      .catch(error => {
        console.log(error);
        throw error.response; // <-- use throw to be able to use catch
      });
  },
  update() {}
};
</script>


// WEBPACK FOOTER //
// src/services/DataService.vue